import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { constructQueryParamName } from '../../../util/search';
import DropdownFilterEnum from '../DropdownFilterEnum/DropdownFilterEnum';

import css from './SearchPageStyles.module.css';

const SEARCH_PARAM = constructQueryParamName('hullMaterial', 'public');

const ORDERED_KEYS = ['grp', 'aluminium', 'steel', 'wood', 'composite', 'hypalon'];

const HullTypeFilter = props => {
  const intl = useIntl();

  const hullMaterialOptions = useMemo(
    () =>
      ORDERED_KEYS.map(material => ({
        value: material,
        label: intl.formatMessage({ id: `General.listing.material.${material}` }),
        searchString: intl.formatMessage({ id: `General.listing.material.${material}` }),
      })),
    [intl]
  );

  return (
    <DropdownFilterEnum
      options={hullMaterialOptions}
      searchParamName={SEARCH_PARAM}
      placeholder={intl.formatMessage({ id: 'EditListingDetailsForm.hullMaterial' })}
      dropdownInputClassName={css.dropdownLabel}
      disableInternalSort
      {...props}
    />
  );
};

export default HullTypeFilter;
